<template>
  <el-card
    class="trace-sequence"
    shadow="never"
    :body-style="{ padding: '10px' }"
  >
    <div slot="header">
      <span style="font-size: 16px"> 路径数据 </span>

      <span
        v-show="timeStr"
        style="color: #999; margin-left: 15px; font-size: 12px"
      >
        {{ timeStr }}
      </span>
    </div>

    <div class="sequence-body">
      <div v-show="times.length > 1" class="sidebar">
        <div v-for="time in times" :key="time.key" class="nav-item">
          <span
            class="nav-link"
            :class="{ active: active === time.key }"
            @click="active = time.key"
            >{{ time.value }}</span
          >
        </div>
      </div>

      <div class="sequence-content">
        <!-- <el-checkbox-group v-model="ignorefields">
                    <el-checkbox label="route">Route</el-checkbox>
                    <el-checkbox label="place">Place</el-checkbox>
                    <el-checkbox label="nodes">Nodes</el-checkbox>
                    <el-checkbox label="nodes0">Nodes0</el-checkbox>
                    <el-checkbox label="plan">Plan</el-checkbox>
                </el-checkbox-group> -->
        <codemirror :value="content" :options="cmOptions" />
      </div>
    </div>
  </el-card>
</template>

<script>
import { codemirror } from 'vue-codemirror'

import 'codemirror/lib/codemirror.css'
import 'codemirror/theme/idea.css'
import 'codemirror/mode/javascript/javascript'

import 'codemirror/addon/fold/foldgutter.css'
import 'codemirror/addon/fold/foldcode'
import 'codemirror/addon/fold/foldgutter'
import 'codemirror/addon/fold/brace-fold'
import 'codemirror/addon/fold/comment-fold'

import dayjs from 'dayjs'

export default {
  components: {
    codemirror,
  },
  props: {
    sequence: {
      type: Object,
    },
  },

  data() {
    return {
      active: '',
      ignorefields: [],
    }
  },

  computed: {
    cmOptions() {
      return {
        tabSize: 4,
        readOnly: true,
        mode: 'application/json',
        theme: 'idea',
        foldGutter: true,
        lineWrapping: true,
        gutters: [
          'CodeMirror-linenumbers',
          'CodeMirror-foldgutter',
          'CodeMirror-lint-markers',
        ],
      }
    },

    timeStr() {
      return (this.times.find(it => it.key === this.active) || {}).value || ''
    },

    content() {
      const text = this.contents.find(it => it.key === this.active) || {}

      if (this.ignorefields.length && text.source) {
        const items = []

        for (const item of text.source) {
          const object = {
            ...item,
          }
          for (const f of this.ignorefields) {
            object[f] = undefined
          }
          items.push(object)
        }
        return JSON.stringify(items, null, 2)
      }

      return text.value || ''
    },

    localSequence() {
      const sequence = this.sequence || {},
        times = [],
        contents = []
      let keys = Object.keys(sequence).sort().reverse()

      for (const k of keys) {
        contents.push({
          key: k,
          source: sequence[k],
          value: JSON.stringify(sequence[k], null, 2),
        })
        times.push({
          key: k,
          value: dayjs(parseInt(k)).format('MM-DD HH:mm:ss'),
        })
      }

      return {
        times,
        contents,
      }
    },

    times() {
      return this.localSequence.times
    },

    contents() {
      return this.localSequence.contents
    },
  },

  watch: {
    times: {
      handler() {
        const time = this.times[0] || {}
        this.active = time.key || ''

        console.log(this.active)
      },
      immediate: true,
    },
  },
}
</script>

<style lang="scss">
.trace-sequence {
  .CodeMirror {
    height: 500px;
    font-size: 13px;
    border: 1px #ccc solid;
  }

  .el-checkbox-group {
    margin-bottom: 5px;
  }
}
</style>

<style lang="scss" scoped>
.trace-sequence {
  border: none;

  .sequence-body {
    display: flex;
    flex-direction: row;

    .sidebar {
      width: 120px;

      display: flex;
      padding-left: 0;
      margin-right: 10px;
      flex-direction: column;

      .nav-item {
        text-align: center;
        font-size: 12px;

        & + .nav-item {
          margin-top: 5px;
        }

        .nav-link {
          border: 0;
          border-radius: 4px;
          display: block;
          padding: 6px 12px;
          text-decoration: none;
          transition: color 0.15s ease-in-out,
            background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
          color: #0d6efd;
          background: 0 0;
          cursor: pointer;

          &.active {
            color: #fff;
            background-color: #0d6efd;
          }
        }
      }
    }

    .sequence-content {
      flex-grow: 1;
    }
  }
}
</style>
